import React from "react"
import Button from "../../components/common/Button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { H2 } from "../../components/typography/Headings"
import P from "../../components/typography/P"

export default function CtaSection({
  title,
  text,
  link,
  linkText,
  image,
  location,
}) {
  const { pathname } = location

  if (pathname === "/verlag/sonderausgaben/sonderausgabe-2025/") {
    return null
  }
  return (
    <div>
      <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="relative overflow-hidden bg-gray-100 rounded-lg shadow-xl lg:grid lg:grid-cols-2 lg:gap-4">
          <div className="px-6 pt-10 pb-12 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
            <div className="lg:self-center">
              <H2>{title}</H2>
              <P className="my-4">{text}</P>
              <Button text={linkText} to={link} />
            </div>
          </div>
          <div>
            <GatsbyImage
              className="object-cover object-left-top transform translate-x-6 translate-y-6 rounded-md sm:translate-x-16 lg:translate-y-20"
              image={getImage(image)}
              alt={`${title} Coverbild`}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
